import { ApolloError } from '@apollo/client'
import { ExecutionResult } from 'graphql'

/**
 * Result similar to ApolloQueryResult and MutationResult
 *
 * Useful for interacting with ApolloClient outside of React hooks
 */
export interface GraphQLResult<
  TData = { [key: string]: unknown },
  TExtensions = { [key: string]: unknown },
> extends ExecutionResult<TData, TExtensions> {
  error?: ApolloError | Error
}

export const graphQLResultFrom = <
  TData = { [key: string]: unknown },
  TExtensions = { [key: string]: unknown },
>(
  result: ExecutionResult<TData, TExtensions>,
): GraphQLResult<TData, TExtensions> =>
  result.errors == null || !result.errors.length
    ? result
    : {
        ...result,
        error: new ApolloError({ graphQLErrors: result.errors }),
      }
